import { useFormContext, useWatch } from 'react-hook-form';

import { ActivityKindEnum, TransactionTypeEnum } from '../../types/enums';
import type { PropertyAdEditorFormValues } from '../../types/propertyAdEditor';

import { EditorSection } from './EditorSection';
import { RentPricingDetails } from './RentPricingDetails';
import { SalePropertyDetails } from './SalePropertyDetails';

export const PricingTransactionSection = () => {
  const { control } = useFormContext<PropertyAdEditorFormValues>();
  const activityKind = useWatch({ control, name: 'activityKind' });
  const transactionType = useWatch({ control, name: 'transactionType' });
  const hasSalePricing =
    activityKind === ActivityKindEnum.Sale &&
    transactionType !== null &&
    [TransactionTypeEnum.Ready, TransactionTypeEnum.Resale, TransactionTypeEnum.Distress].includes(
      transactionType
    );

  if (activityKind !== ActivityKindEnum.Rent && !hasSalePricing) {
    return null;
  }

  return (
    <EditorSection
      cardTestId='pricing-transaction-card'
      description='Pricing and transaction-specific information'
      title='Pricing & Transaction Details'
      titleId='pricing-transaction-title'
    >
      {activityKind === ActivityKindEnum.Sale && <SalePropertyDetails />}
      {activityKind === ActivityKindEnum.Rent && <RentPricingDetails />}
    </EditorSection>
  );
};
